import { render, staticRenderFns } from "./indexContent.vue?vue&type=template&id=224c9992&scoped=true&"
import script from "./indexContent.vue?vue&type=script&lang=js&"
export * from "./indexContent.vue?vue&type=script&lang=js&"
import style0 from "./indexContent.vue?vue&type=style&index=0&id=224c9992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224c9992",
  null
  
)

export default component.exports